<template>
    <div id="extra-info-loyalty">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section mb--100">
            <div class="container">
                <div class="project-add-banner bg-gradient-green fix-padding" data-sal="slide-up" data-sal-duration="800">
                    <div class="content">
                        <div class="row center">
                            <div class="col-sm-12 col-md-12">
                                <h1 class="subtitle" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">Los Compromisos del Programa.</h1>
                                <h2 class="font-weight-100 dark mb-0">
                                    Cumple con los distintos <span class="bold">compromisos,</span> 
                                    sube de nivel y ¡olvídate de la comisión!
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-4" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                        <div class="project-grid">
                            <div class="thumbnail">
                                <img :src="`${logo_base}inversion.png`" alt="project">
                            </div>
                            <div class="content">
                                <h4 class="title bold">Inversión Automática</h4>
                                <span class="subtitle text-wrap-balance">
                                    Tu compromiso está en generar un <i>interés compuesto</i>
                                    para ti y el medio ambiente.
                                </span>
                                <button @click.stop="goToAppLogin()" class="axil-btn btn-fill-primary mt--20 bold text-dark">Activalo</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4" data-sal="slide-up" data-sal-duration="800" data-sal-delay="200">
                        <div class="project-grid">
                            <div class="thumbnail">
                                <img :src="`${logo_base}abono.png`" alt="project">
                            </div>
                            <div class="content">
                                <h4 class="title bold">Abono Recurrente</h4>
                                <span class="subtitle text-wrap-balance">
                                    Tu compromiso está en abonar recurrentemente para limpiar al planeta.
                                </span>
                                <button @click.stop="goToAppLogin()" class="axil-btn btn-fill-primary mt--20 bold text-dark">Activalo</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4" data-sal="slide-up" data-sal-duration="800" data-sal-delay="300">
                        <div class="project-grid">
                            <div class="thumbnail">
                                <img :src="`${logo_base}campo.png`" alt="project">
                            </div>
                            <div class="content">
                                <h4 class="title bold">Campo de Girasoles</h4>
                                <span class="subtitle text-wrap-balance">
                                    Tu compromiso está en trabajar en equipo para lograr 
                                    grandes cambios.
                                </span>
                                <button @click.stop="goToAppLogin()" class="axil-btn btn-fill-primary mt--20 bold text-dark">Activalo</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "ExtraInfo",
    components: {
    },
    data() {
        return {
            logo_base: "https://cdn.redgirasol.com/nuevo_portal/banners/programa-compromiso/banner-"
        }
    }
}

</script>

<style scoped>
.center {
    align-items: center;
}

.fix-padding {
    padding-top: 5rem;
    padding-bottom: 5rem;
}
</style>